<nav *ngIf="gatePass" class="navbar navbar-expand-md navbar-light green-theme" role="navigation" id="navbar">

  <div class="container">
    <div class="border-round-top  w-100">
      <div class="nav nav-justified navbar-nav expand-width" id="main-nav">
          <span class="logo-span">
            <a [routerLink]="pathToHome"> <img src="/assets/images/boldungu_logo.png" width="40"/></a>
          </span>

          <span *ngIf="gatePass.is_role_admin" class="nav-item dropdown main-nav-drop">
            <app-menu-item-user-admin ></app-menu-item-user-admin>
          </span>
          <span *ngIf="gatePass.is_logged_in" class="nav-item">
            <app-menu-item-home
            [student]="student"
            [guardian]="guardian"
            [gatePass]="gatePass"></app-menu-item-home>
          </span>

          <span *ngIf="gatePass.is_role_guardian && gatePass.is_logged_in" class="nav-item">
            <app-menu-item-group
            [student]="student"
            [guardian]="guardian"
            [gatePass]="gatePass"></app-menu-item-group>
          </span>

          <span *ngIf="!gatePass.is_logged_in"  class="nav-item">
            <a [routerLink]="['static/display/service/offering']" class="nav-link">
              <i class='fa fa-angellist'></i>
              <div>Services</div></a>
          </span>
          <span *ngIf="!gatePass.is_logged_in" class="nav-item">
            <a [routerLink]="['info/access/plans']" class="nav-link"><i class='fa fa-key'></i> <div>Access Plans</div></a>
          </span>
          <span *ngIf="(gatePass.is_role_student || gatePass.is_role_guardian)&& gatePass.is_logged_in" class="nav-item dropdown main-nav-drop">
            <app-report-menu [gatePass]="gatePass"></app-report-menu>
          </span>
          <span *ngIf="(gatePass.is_role_student || gatePass.is_role_guardian) && gatePass.is_logged_in"  class="nav-item">
            <a [routerLink]="['study/material/index/',gatePass.user_id]" class="nav-link nav-main-white">
              <i class="fa fa-book"></i>
              <div> Study Material </div> </a>
          </span>
          <span *ngIf="(!gatePass.is_role_student && gatePass.is_logged_in)" class="nav-item dropdown main-nav-drop">
              <app-guardian-tools-and-services
              [gatePass]="gatePass">
            </app-guardian-tools-and-services>
          </span>
          <span *ngIf="gatePass.is_role_student" class="nav-item">
              <a [routerLink]="['/student/messaging/home',gatePass.user_id]"  class="nav-link nav-main-white"><div class="button"><i class="fa fa-envelope-o"> </i><span class="button__badge">0</span></div><div>Messaging</div> </a>
          </span>
          <span *ngIf="!gatePass.is_logged_in" class="nav-item">
            <a [routerLink]="['/blog']"  class="nav-link"><i class="fa fa-empire"> </i><div>Blog</div> </a>
          </span>
          <span class="nav-item" *ngIf="!gatePass.is_logged_in">
           <a [routerLink]="['free/worksheets']"  class="nav-link nav-main-white">
           <i class='fa fa-cubes'></i>
            <div> Quick Worksheets </div>
            </a>
          </span>

          <span class="nav-item px-2 vertical-auto" *ngIf="!gatePass.is_logged_in">
            <a [routerLink]="['user/login']" class="nav-link"><i class='fa fa-sign-in'></i> <div>Login</div></a>
          </span>
          <span class="nav-item px-2 vertical-auto" *ngIf="!gatePass.is_logged_in">
            <a [routerLink]="['/user/new/step/one']"  class="nav-link"><i class='fa fa-dot-circle-o'></i> <div>Register Here</div> </a>
          </span>
          <span  class="vertical-auto nav-item dropdown main-nav-drop">
            <app-menu-item-user [gatePass]="gatePass"></app-menu-item-user>
          </span>

        </div>
      </div>
  </div>
</nav>
<hr/>

